// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LumiRoute from "lumi-rescript/lib/es6/src/LumiRoute.res.js";
import * as Spinner$Web from "lumi-web/lib/es6/src/Spinner.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Map$LumiFacilityMap from "lumi-facility-map/lib/es6/src/Map.res.js";
import * as FacilityMap$Dashboard from "./FacilityMap.res.js";
import * as Translation$Dashboard from "./Translation.res.js";
import * as ObjectStyle$LumiFacilityMap from "lumi-facility-map/lib/es6/src/ObjectStyle.res.js";

function seconds(pd) {
  let day = 24 * 3600;
  let week = 7 * day;
  switch (pd) {
    case "OneHour" :
      return 3600;
    case "TwoHours" :
      return 2 * 3600;
    case "SixHours" :
      return 6 * 3600;
    case "TwelveHours" :
      return 12 * 3600;
    case "OneDay" :
      return day;
    case "OneWeek" :
      return week;
    case "TwoWeeks" :
      return 2 * week;
    case "OneMonth" :
      return 30 * day;
  }
}

function calcSensorStyles(sensorStyles, parkingDuration, sensorStates) {
  let cutoff = Date.now() - seconds(parkingDuration) * 1000;
  return Map$LumiFacilityMap.SensorStyles.merge(sensorStyles, Map$LumiFacilityMap.SensorStyles.fromArray(sensorStates.map(sensorState => [
    sensorState.sensorKey,
    ObjectStyle$LumiFacilityMap.make(undefined, undefined, undefined, undefined, [[
        "abandoned",
        sensorState.measurement.free !== 0 ? false : sensorState.changeTime.getTime() < cutoff
      ]], undefined)
  ])));
}

function countAbandonedVehicles(parkingDuration, sensorStates) {
  let cutoff = Date.now() - seconds(parkingDuration) * 1000;
  return sensorStates.filter(sensorState => {
    if (sensorState.measurement.free !== 0) {
      return false;
    } else {
      return sensorState.changeTime.getTime() < cutoff;
    }
  }).length;
}

let parkingDurations = [
  [
    "OneHour",
    {
      TAG: "HoursOrLonger",
      _0: 1
    }
  ],
  [
    "TwoHours",
    {
      TAG: "HoursOrLonger",
      _0: 2
    }
  ],
  [
    "SixHours",
    {
      TAG: "HoursOrLonger",
      _0: 6
    }
  ],
  [
    "TwelveHours",
    {
      TAG: "HoursOrLonger",
      _0: 12
    }
  ],
  [
    "OneDay",
    {
      TAG: "DaysOrLonger",
      _0: 1
    }
  ],
  [
    "OneWeek",
    {
      TAG: "WeeksOrLonger",
      _0: 1
    }
  ],
  [
    "TwoWeeks",
    {
      TAG: "WeeksOrLonger",
      _0: 2
    }
  ],
  [
    "OneMonth",
    {
      TAG: "MonthsOrLonger",
      _0: 1
    }
  ]
];

function spd(s) {
  switch (s) {
    case "1" :
      return "OneHour";
    case "2" :
      return "TwoHours";
    case "3" :
      return "SixHours";
    case "4" :
      return "TwelveHours";
    case "5" :
      return "OneDay";
    case "7" :
      return "TwoWeeks";
    case "8" :
      return "OneMonth";
    default:
      return "OneWeek";
  }
}

function pds(p) {
  switch (p) {
    case "OneHour" :
      return "1";
    case "TwoHours" :
      return "2";
    case "SixHours" :
      return "3";
    case "TwelveHours" :
      return "4";
    case "OneDay" :
      return "5";
    case "OneWeek" :
      return "6";
    case "TwoWeeks" :
      return "7";
    case "OneMonth" :
      return "8";
  }
}

function AbandonedVehicles$Footer(props) {
  let setParkingDuration = props.setParkingDuration;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
          entry: "ParkingDuration"
        }),
        className: "panel-block has-text-weight-bold"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx("select", {
            children: parkingDurations.map(param => {
              let duration = param[0];
              return JsxRuntime.jsx("option", {
                children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                  entry: param[1]
                }),
                value: pds(duration)
              }, pds(duration));
            }),
            value: pds(props.parkingDuration),
            onChange: e => {
              let pd = spd(e.target.value);
              setParkingDuration(param => pd);
            }
          }),
          className: "select is-fullwidth"
        }),
        className: "panel-block"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
          entry: {
            TAG: "NumAbandonedVehicles",
            _0: props.numAbandonedVehicles
          }
        }),
        className: "panel-block has-text-weight-bold"
      })
    ]
  });
}

let Footer = {
  make: AbandonedVehicles$Footer
};

function AbandonedVehicles(props) {
  let facilityInfos = props.facilityInfos;
  let mapUrl = props.mapUrl;
  let map = props.map;
  let mbFacilityMapKey = Stdlib_Option.map(map, m => m.map);
  let selectedSensorKey = Stdlib_Option.flatMap(map, m => m.selection);
  let facilityMapUrl = (facilityMapKey, mbSelectedSensorKey) => mapUrl({
    map: facilityMapKey,
    transform: Stdlib_Option.getOr(Stdlib_Option.map(map, m => {
      if (m.map === facilityMapKey) {
        return m.transform;
      } else {
        return Transform$Linear.M23f.identity;
      }
    }), Transform$Linear.M23f.identity),
    selection: Stdlib_Option.getOr(mbSelectedSensorKey, selectedSensorKey)
  });
  let facilityMaps = FacilityMap$Dashboard.useFacilityMaps(mbFacilityMapKey, selectedSensorKey, facilityMapUrl, facilityInfos);
  let match = facilityMaps.state;
  let sensorStates = match.sensorStates;
  let parentSensorStyles = match.sensorStyles;
  let facilityMap = match.facilityMap;
  let match$1 = React.useState(() => "OneWeek");
  let parkingDuration = match$1[0];
  let sensorStyles = React.useMemo(() => calcSensorStyles(parentSensorStyles, parkingDuration, sensorStates), [
    parentSensorStyles,
    parkingDuration,
    sensorStates
  ]);
  let numAbandonedVehicles = countAbandonedVehicles(parkingDuration, sensorStates);
  let onSelectSensor = selectedSensorKey => {
    if (mbFacilityMapKey !== undefined) {
      return LumiRoute.followUrl(facilityMapUrl(mbFacilityMapKey, Primitive_option.some(selectedSensorKey)), undefined);
    }
  };
  let showLayer = layer => {
    switch (layer) {
      case "Camera" :
      case "Display" :
      case "Indicator" :
        return false;
      default:
        return true;
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(FacilityMap$Dashboard.Sidebar.make, {
        facilityMaps: facilityMaps,
        facilityInfos: facilityInfos,
        toApplication: props.toApplication,
        facilityMapUrl: fm => facilityMapUrl(fm, undefined),
        children: JsxRuntime.jsx(AbandonedVehicles$Footer, {
          parkingDuration: parkingDuration,
          setParkingDuration: match$1[1],
          numAbandonedVehicles: numAbandonedVehicles
        })
      }),
      JsxRuntime.jsx("div", {
        children: facilityMap !== undefined && map !== undefined ? JsxRuntime.jsx(Map$LumiFacilityMap.make, {
            facilityMap: facilityMap,
            mapTransform: map.transform,
            setMapTransform: f => LumiRoute.followUrl(mapUrl({
              map: map.map,
              transform: f(map.transform),
              selection: map.selection
            }), undefined),
            showLayer: showLayer,
            sensorStyles: Primitive_option.some(sensorStyles),
            panButton: "Main",
            onClickBackground: param => onSelectSensor(undefined),
            onClickParkingPlace: (_event, _svgId, mbSensorKey) => onSelectSensor(mbSensorKey)
          }) : JsxRuntime.jsx(Spinner$Web.make, {}),
        className: "column contents"
      })
    ]
  });
}

let make = AbandonedVehicles;

export {
  seconds,
  calcSensorStyles,
  countAbandonedVehicles,
  parkingDurations,
  spd,
  pds,
  Footer,
  make,
}
/* react Not a pure module */
